import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useInfiniteQuery } from '@tanstack/react-query';
import { EntryApiAdapter } from '../../adapters';
import { EntryFilters } from '../../models';
import { EntryService } from '../services/EntryService';

export const useEntries = (filters: EntryFilters = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new EntryApiAdapter(httpClient);
  const service = new EntryService(apiAdapter);

  const {
    data,
    isLoading,
    isFetching,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isPending,
  } = useInfiniteQuery({
    queryKey: ['merchandise-v3-entries', filters],
    queryFn: ({ pageParam = 1 }) =>
      service.getPaginated({
        ...filters,
        page: pageParam,
      }),
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    staleTime: 5 * 60 * 1000,
    placeholderData: (previousData) => previousData,
  });

  const entries = data?.pages.flatMap((page) => page.entries) ?? [];

  // Obtener el total del API (siempre será el mismo en todas las páginas)
  const totalFromApi = data?.pages?.[0]?.total ?? 0;

  return {
    entries,
    isLoading: isLoading || isPending,
    isFetching,
    error,
    refetch,
    fetchNextPage,
    hasNextPage: hasNextPage ?? false,
    isFetchingNextPage,
    totalPages: data?.pages.length ?? 0,
    totalEntries: entries.length,
    total: totalFromApi,
  };
};

